import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function atLeastOne(fieldNames: string[]): ValidatorFn {
	if (!fieldNames) throw new Error('Fields not supplied for validation');

	return (group: UntypedFormGroup): any => {
		const fields = fieldNames.map(name => group.get(name));

		return !fields.some(field => field.value || field.value === 0) ? { atLeastOne: true } : null;
	};
}
